// M02 恆等式 - 練習題數據
// 系統化設計，準備後續 Supabase 數據遷移
// 總計 140 題，涵蓋 14 個學習主題

// 導入所有主題的問題數據
import { 
  M02_01_PROBLEMS, M02_02_PROBLEMS, M02_03_PROBLEMS, M02_04_PROBLEMS, M02_05_PROBLEMS 
} from './M02_Topics_01_to_05.js';

import { 
  M02_06_PROBLEMS, M02_07_PROBLEMS, M02_08_PROBLEMS, M02_09_PROBLEMS, M02_10_PROBLEMS 
} from './M02_Topics_06_to_10.js';

import { 
  M02_11_PROBLEMS, M02_12_PROBLEMS, M02_13_PROBLEMS, M02_14_PROBLEMS 
} from './M02_Topics_11_to_14.js';

// ========== 主題定義 ==========
export const M02_TOPICS = [
  {
    id: 'M02_01',
    title: "多項式展開",
    description: "使用分配律展開多項式表達式，掌握FOIL法和分配律的應用",
    problemCount: 10,
    difficulty: 'easy',
    order: 1
  },
  {
    id: 'M02_02',
    title: "平方恆等式", 
    description: "運用 (a ± b)² = a² ± 2ab + b² 恆等式進行展開和因式分解",
    problemCount: 10,
    difficulty: 'easy',
    order: 2
  },
  {
    id: 'M02_03',
    title: "恆等式證明",
    description: "證明代數恆等式的正確性，培養邏輯推理能力",
    problemCount: 10,
    difficulty: 'medium',
    order: 3
  },
  {
    id: 'M02_04',
    title: "二次式因式分解",
    description: "將二次表達式分解為兩個一次式的乘積，包括完全平方和平方差",
    problemCount: 10,
    difficulty: 'medium',
    order: 4
  },
  {
    id: 'M02_05',
    title: "平方差恆等式",
    description: "運用 a² - b² = (a + b)(a - b) 恆等式進行計算和證明",
    problemCount: 10,
    difficulty: 'medium',
    order: 5
  },
  {
    id: 'M02_06',
    title: "立方和恆等式",
    description: "運用 a³ + b³ = (a + b)(a² - ab + b²) 恆等式及其應用",
    problemCount: 10,
    difficulty: 'medium',
    order: 6
  },
  {
    id: 'M02_07',
    title: "平方和恆等式",
    description: "處理 a² + b² 類型的表達式和相關恆等式",
    problemCount: 10,
    difficulty: 'medium',
    order: 7
  },
  {
    id: 'M02_08',
    title: "高次方推導",
    description: "推導和應用高次方的恆等式，包括二項式定理的基本應用",
    problemCount: 10,
    difficulty: 'hard',
    order: 8
  },
  {
    id: 'M02_09',
    title: "三元平方恆等式",
    description: "處理含有三個變數的平方恆等式和相關應用",
    problemCount: 10,
    difficulty: 'hard',
    order: 9
  },
  {
    id: 'M02_10',
    title: "畢氏恆等式",
    description: "運用畢氏定理相關的恆等式，包括三角函數基本恆等式",
    problemCount: 10,
    difficulty: 'medium',
    order: 10
  },
  {
    id: 'M02_11',
    title: "衍生恆等式",
    description: "從基本恆等式推導出的複合恆等式和高級應用",
    problemCount: 10,
    difficulty: 'hard',
    order: 11
  },
  {
    id: 'M02_12',
    title: "三角表達式化簡",
    description: "化簡含有三角函數的代數表達式，掌握基本三角恆等式",
    problemCount: 10,
    difficulty: 'medium',
    order: 12
  },
  {
    id: 'M02_13',
    title: "多項式展開",
    description: "展開較複雜的多項式表達式，包括高次和多元展開",
    problemCount: 10,
    difficulty: 'hard',
    order: 13
  },
  {
    id: 'M02_14',
    title: "因式定理應用",
    description: "使用因式定理進行因式分解和求解，掌握有理根定理",
    problemCount: 10,
    difficulty: 'hard',
    order: 14
  }
];

// ========== 模組資訊 ==========
export const M02_MODULE_INFO = {
  moduleId: 'M02',
  title: '恆等式',
  description: '學習代數恆等式的展開、因式分解、證明和應用，建立堅實的代數基礎',
  totalTopics: M02_TOPICS.length,
  totalProblems: 140,
  estimatedTime: '12-15小時',
  difficulty: 'Intermediate',
  prerequisites: ['基本代數運算', '多項式概念', 'M01數系與近似值'],
  learningObjectives: [
    '掌握各種恆等式的展開和因式分解技巧',
    '能夠證明代數恆等式並理解其數學意義',
    '熟練應用因式定理解決實際問題',
    '理解三角恆等式的基本概念和應用',
    '能夠化簡複雜的代數表達式',
    '培養邏輯推理和代數操作能力'
  ],
  keyFormulas: [
    '完全平方：(a ± b)² = a² ± 2ab + b²',
    '平方差：a² - b² = (a + b)(a - b)',
    '立方和：a³ + b³ = (a + b)(a² - ab + b²)',
    '立方差：a³ - b³ = (a - b)(a² + ab + b²)',
    '三元平方：(a + b + c)² = a² + b² + c² + 2ab + 2bc + 2ca',
    '基本三角恆等式：sin²θ + cos²θ = 1'
  ]
};

// ========== 問題數據整合 ==========
export const M02_PROBLEMS_DATA = {
  'M02_01': M02_01_PROBLEMS,
  'M02_02': M02_02_PROBLEMS,
  'M02_03': M02_03_PROBLEMS,
  'M02_04': M02_04_PROBLEMS,
  'M02_05': M02_05_PROBLEMS,
  'M02_06': M02_06_PROBLEMS,
  'M02_07': M02_07_PROBLEMS,
  'M02_08': M02_08_PROBLEMS,
  'M02_09': M02_09_PROBLEMS,
  'M02_10': M02_10_PROBLEMS,
  'M02_11': M02_11_PROBLEMS,
  'M02_12': M02_12_PROBLEMS,
  'M02_13': M02_13_PROBLEMS,
  'M02_14': M02_14_PROBLEMS
};

// ========== 統計資訊 ==========
export const M02_STATISTICS = {
  totalProblems: 140,
  totalTopics: 14,
  difficultyDistribution: {
    easy: 20,      // 主題 1-2
    medium: 70,    // 主題 3-7, 10, 12
    hard: 50       // 主題 8-9, 11, 13-14
  },
  averageProblemsPerTopic: 10,
  estimatedCompletionTime: '12-15小時',
  topicCategories: {
    basic_expansion: ['M02_01', 'M02_02'],           // 基礎展開
    factorization: ['M02_04', 'M02_05', 'M02_06'],  // 因式分解
    identity_proof: ['M02_03', 'M02_11'],           // 恆等式證明
    advanced_algebra: ['M02_08', 'M02_09', 'M02_13'], // 高等代數
    applications: ['M02_07', 'M02_10', 'M02_12', 'M02_14'] // 實際應用
  }
};

// ========== 工具函數 ==========

/**
 * 獲取所有 M02 問題
 * @returns {Array} 所有問題的數組
 */
export const getAllM02Problems = () => {
  return Object.values(M02_PROBLEMS_DATA).flat();
};

/**
 * 根據主題ID獲取問題
 * @param {string} topicId - 主題ID
 * @returns {Array} 該主題的所有問題
 */
export const getProblemsByTopicId = (topicId) => {
  return M02_PROBLEMS_DATA[topicId] || [];
};

/**
 * 根據難度獲取問題
 * @param {string} difficulty - 難度級別 ('easy', 'medium', 'hard')
 * @returns {Array} 指定難度的所有問題
 */
export const getProblemsByDifficulty = (difficulty) => {
  const difficultyMap = {
    1: 'easy',
    2: 'medium', 
    3: 'hard'
  };
  
  return getAllM02Problems().filter(problem => 
    difficultyMap[problem.difficulty] === difficulty
  );
};

/**
 * 隨機獲取問題
 * @param {number} count - 需要的問題數量
 * @param {string} topicId - 可選的主題ID限制
 * @returns {Array} 隨機選取的問題數組
 */
export const getRandomProblems = (count, topicId = null) => {
  const sourceProblems = topicId ? getProblemsByTopicId(topicId) : getAllM02Problems();
  const shuffled = [...sourceProblems].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

/**
 * 根據類別獲取主題
 * @param {string} category - 類別名稱
 * @returns {Array} 該類別的主題數組
 */
export const getTopicsByCategory = (category) => {
  const categoryTopics = M02_STATISTICS.topicCategories[category] || [];
  return M02_TOPICS.filter(topic => categoryTopics.includes(topic.id));
};

// ========== 數據驗證 ==========

/**
 * 驗證 M02 數據的完整性
 * @returns {Object} 驗證結果
 */
export const validateM02Data = () => {
  const results = {
    isValid: true,
    errors: [],
    warnings: [],
    summary: {}
  };

  // 檢查每個主題的問題數量
  M02_TOPICS.forEach(topic => {
    const problems = getProblemsByTopicId(topic.id);
    if (problems.length !== 10) {
      results.errors.push(`主題 ${topic.id} 應有 10 題，實際有 ${problems.length} 題`);
      results.isValid = false;
    }
    
    // 檢查問題ID的唯一性
    const ids = problems.map(p => p.id);
    const uniqueIds = new Set(ids);
    if (ids.length !== uniqueIds.size) {
      results.errors.push(`主題 ${topic.id} 存在重複的問題ID`);
      results.isValid = false;
    }
    
    // 檢查必要字段
    problems.forEach((problem, index) => {
      const requiredFields = ['id', 'topicId', 'question', 'solution', 'explanation', 'difficulty', 'order'];
      requiredFields.forEach(field => {
        if (!problem[field]) {
          results.errors.push(`主題 ${topic.id} 第 ${index + 1} 題缺少必要字段: ${field}`);
          results.isValid = false;
        }
      });
    });
  });

  // 統計摘要
  results.summary = {
    totalProblems: getAllM02Problems().length,
    totalTopics: M02_TOPICS.length,
    problemsPerTopic: M02_TOPICS.map(topic => ({
      topicId: topic.id,
      count: getProblemsByTopicId(topic.id).length
    }))
  };

  return results;
};

// ========== Supabase 遷移準備 ==========

/**
 * 準備 Supabase 數據遷移格式
 * @returns {Object} 格式化的數據
 */
export const prepareForSupabaseImport = () => {
  const timestamp = new Date().toISOString();
  
  return {
    module: {
      ...M02_MODULE_INFO,
      createdAt: timestamp,
      updatedAt: timestamp,
      isActive: true
    },
    topics: M02_TOPICS.map(topic => ({
      ...topic,
      moduleId: 'M02',
      createdAt: timestamp,
      updatedAt: timestamp,
      isActive: true
    })),
    problems: getAllM02Problems().map(problem => ({
      ...problem,
      moduleId: 'M02',
      createdAt: timestamp,
      updatedAt: timestamp,
      isActive: true,
      tags: generateProblemTags(problem)
    })),
    statistics: {
      ...M02_STATISTICS,
      generatedAt: timestamp
    }
  };
};

/**
 * 生成問題標籤
 * @param {Object} problem - 問題對象
 * @returns {Array} 標籤數組
 */
const generateProblemTags = (problem) => {
  const tags = [];
  
  // 基於難度的標籤
  const difficultyMap = { 1: 'easy', 2: 'medium', 3: 'hard' };
  tags.push(difficultyMap[problem.difficulty] || 'unknown');
  
  // 基於主題的標籤
  const topicInfo = M02_TOPICS.find(t => t.id === problem.topicId);
  if (topicInfo) {
    tags.push(topicInfo.title.toLowerCase().replace(/\s+/g, '_'));
  }
  
  // 基於內容的標籤
  if (problem.question.includes('證明')) tags.push('proof');
  if (problem.question.includes('因式分解')) tags.push('factorization');
  if (problem.question.includes('展開')) tags.push('expansion');
  if (problem.question.includes('計算')) tags.push('calculation');
  
  return tags;
};

// ========== 導出默認對象 ==========
export default {
  MODULE_INFO: M02_MODULE_INFO,
  TOPICS: M02_TOPICS,
  PROBLEMS_DATA: M02_PROBLEMS_DATA,
  STATISTICS: M02_STATISTICS,
  getAllProblems: getAllM02Problems,
  getProblemsByTopicId,
  getProblemsByDifficulty,
  getRandomProblems,
  validateData: validateM02Data,
  prepareForSupabaseImport
}; 